//解决页面布局 table高度适配问题，不是每个页面都实用，如果需要使用这个插件
//就需要在需要根据高度改变的table或者容器  利用 全局变量 tableHeigth 设定对应容器高度
//例如：<el-table :height="tableHeigth">
var lpyMixin = {
    data: function() {
        return {
            tableHeigth: 0,
            tableHeightSubtract: 370, //table高度计算减去的值
        }
    },
    created() {
        this.resetSize();
    },
    beforeMount() {
        window.addEventListener("resize", this.resetSize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resetSize);
    },
    methods: {
        resetSize() {
            let h = document.documentElement.clientHeight || document.body.clientHeight;
            this.tableHeigth = h - this.tableHeightSubtract;
            // console.log(`可视化高度：${h}， table高度：${this.tableHeigth}`)
        }

    },
    watch: {
        tableHeightSubtract: function(newQuestion, oldQuestion) {
            this.resetSize()
        }
    }
}
export default lpyMixin
